import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompanyFeatureKey } from './company-feature-key';

import { CompanyState } from './company.state';

export const CompanyFeatureSelector =
  createFeatureSelector<CompanyState>(CompanyFeatureKey);
// All Company
export const allCompaniesSelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.allCompanies;
  }
);
// Add Company
export const addCompanySelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.addCompany;
  }
);
// All Payment History
export const paymentHistorySelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.paymentHistory;
  }
);
// Contact Company
export const contactCompanySelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.contactCompany;
  }
);
// Member By Id
export const memberByIdSelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.memberById;
  }
);
// Approver By Company Id
export const approversByCompanyIdSelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.approverByCompanyId;
  }
);
// Delete Company
export const deleteCompanySelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.deleteCompany;
  }
);
// All Company
export const companyByIdSelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.companyById;
  }
);
// Send Invocie
export const sendInvoiceSelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.sendInvoice;
  }
);

// Update Company
export const updateCompanySelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.updateCompany;
  }
);
// Remove Member
export const removeMemberSelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.removeMember;
  }
);

/**
 * All Company Selector
 */
export const allCompaniesSuccessSelector = createSelector(
  allCompaniesSelector,
  (state) => {
    return state.data;
  }
);

export const allCompaniesFailureSelector = createSelector(
  allCompaniesSelector,
  (state) => {
    return state.failure;
  }
);
export const allCompaniesLoadingSelector = createSelector(
  allCompaniesSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Company By Id
 */
export const companyByIdSuccessSelector = createSelector(
  companyByIdSelector,
  (state) => {
    return state.data;
  }
);
export const companyByIdFailureSelector = createSelector(
  companyByIdSelector,
  (state) => {
    return state.failure;
  }
);
export const companyByIdLoadingSelector = createSelector(
  companyByIdSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Update Company
 */
export const updateCompanySuccessSelector = createSelector(
  updateCompanySelector,
  (state) => {
    return state.data;
  }
);
export const updateCompanyFailureSelector = createSelector(
  updateCompanySelector,
  (state) => {
    return state.failure;
  }
);
export const updateCompanyLoadingSelector = createSelector(
  updateCompanySelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Update Company
 */
export const removeMemberSuccessSelector = createSelector(
  removeMemberSelector,
  (state) => {
    return state.data;
  }
);
export const removeMemberFailureSelector = createSelector(
  removeMemberSelector,
  (state) => {
    return state.failure;
  }
);
export const removeMemberLoadingSelector = createSelector(
  removeMemberSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Member By Id
 */
export const memberByIdSuccessSelector = createSelector(
  memberByIdSelector,
  (state) => {
    return state.data;
  }
);
export const memberByIdFailureSelector = createSelector(
  memberByIdSelector,
  (state) => {
    return state.failure;
  }
);
export const memberByIdLoadingSelector = createSelector(
  memberByIdSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Delete Company
 */
export const deleteCompanySuccessSelector = createSelector(
  deleteCompanySelector,
  (state) => {
    return state.data;
  }
);
export const deleteCompanyFailureSelector = createSelector(
  deleteCompanySelector,
  (state) => {
    return state.failure;
  }
);
export const deleteCompanyLoadingSelector = createSelector(
  deleteCompanySelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Send Invoice
 */
export const sendInvoiceSuccessSelector = createSelector(
  sendInvoiceSelector,
  (state) => {
    return state.data;
  }
);
export const sendInvoiceFailureSelector = createSelector(
  sendInvoiceSelector,
  (state) => {
    return state.failure;
  }
);
export const sendInvoiceLoadingSelector = createSelector(
  sendInvoiceSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * PaymentHistory
 */
export const paymentHistorySuccessSelector = createSelector(
  paymentHistorySelector,
  (state) => {
    return state.data;
  }
);
export const paymentHistoryFailureSelector = createSelector(
  paymentHistorySelector,
  (state) => {
    return state.failure;
  }
);
export const paymentHistoryLoadingSelector = createSelector(
  paymentHistorySelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Add Company
 */
export const addCompanySuccessSelector = createSelector(
  addCompanySelector,
  (state) => {
    return state.data;
  }
);
export const addCompanyFailureSelector = createSelector(
  addCompanySelector,
  (state) => {
    return state.failure;
  }
);
export const addCompanyLoadingSelector = createSelector(
  addCompanySelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Approver By Company Id
 */
export const approversByCompanyIdSuccessSelector = createSelector(
  approversByCompanyIdSelector,
  (state) => {
    return state.data;
  }
);
export const approversByCompanyIdFailureSelector = createSelector(
  approversByCompanyIdSelector,
  (state) => {
    return state.failure;
  }
);
export const approversByCompanyIdLoadingSelector = createSelector(
  approversByCompanyIdSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Contact Company
 */
export const contactCompanySuccessSelector = createSelector(
  contactCompanySelector,
  (state) => {
    return state.data;
  }
);
export const contactCompanyFailureSelector = createSelector(
  contactCompanySelector,
  (state) => {
    return state.failure;
  }
);
export const contactCompanyLoadingSelector = createSelector(
  contactCompanySelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Contact Company
 */
export const validateCompanySelector = createSelector(
  CompanyFeatureSelector,
  (state) => {
    return state.validateCompany;
  }
);
export const validateCompanySuccessSelector = createSelector(
  validateCompanySelector,
  (state) => {
    return state.data;
  }
);
export const validateCompanyFailureSelector = createSelector(
  validateCompanySelector,
  (state) => {
    return state.failure;
  }
);
export const validateCompanyLoadingSelector = createSelector(
  validateCompanySelector,
  (state) => {
    return state.loading;
  }
);
